import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PasswordValidatorDirective} from './password-validator.directive';
import {PasswordEntryComponent} from './password-entry.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    PasswordValidatorDirective,
    PasswordEntryComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentSetupModule
  ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class PasswordEntryModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(PasswordEntryComponent, 'sc-password-entry', this.injector, pjson.version);
    customElementService.convertToCustomElement(PasswordEntryComponent, 'cc-password-entry', this.injector, pjson.version);
    customElementService.convertToCustomElement(PasswordEntryComponent, 'ft-password-entry', this.injector, pjson.version);

  }
}
